import {IManageTeamState} from '../../../api/manageTeam/types';

export const selectUsers = (state: IManageTeamState) => state.manageTeam.data.users;
export const selectUser = (state: IManageTeamState) => state.manageTeam.data.selectedUser;
export const selectTotalRecords = (state: IManageTeamState) => state.manageTeam.data.page.total;
export const selectRoles = (state: IManageTeamState) => state.manageTeam.data.roles;
export const selectProductOptions = (state: IManageTeamState) =>
    state.manageTeam.data.products?.products?.map((product) => ({name: product.name}));
